import GeneratedDataImportJobStore from "./generated/GeneratedDataImportJobStore"

class DataImportJobStore extends GeneratedDataImportJobStore {

}

export const dataImportJobStore = new DataImportJobStore()
